import React from 'react'
import dayjs from 'dayjs'

import { ArrowThinRight as ArrowIcon } from 'components/Icons'

const DeliveryDate = ({ date }) => {
  const dateObj = dayjs(date)

  return (
    <div className="flex gap-3 pl-3 lg:flex-col lg:gap-0 lg:p-0 lg:w-[116px]">
      <div className="lg:flex lg:justify-between lg:items-center">
        <span
          data-test-id="cart_delivery-box_day"
          className="text-[40px] font-medium leading-10 lg:text-[30px] lg:font-bold"
        >
          {dateObj.format('D')}
          <span
            data-test-id="cart_delivery-box_month"
            className="text-grey-700 hidden lg:inline"
          >
            {`.${dateObj.format('MM')}`}
          </span>
        </span>
        <div className="hidden lg:block">
          <ArrowIcon />
        </div>
      </div>
      <div className="flex flex-col">
        <span
          data-test-id="cart_delivery-box_month-name"
          className="text-12 capitalize text-green-600 lg:hidden"
        >
          {dateObj.format('D MMMM').split(' ')[1]}
        </span>
        <span
          data-test-id="cart_delivery-box_weekday"
          className="text-12 capitalize lg:text-label-13 lg:text-green-600 lg:pl-0.5"
        >
          {dateObj.format('dddd')}
        </span>
      </div>
    </div>
  )
}

export default DeliveryDate
